import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    // Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
    Fade,
    Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const PurchaseOrderListing = () => {
    const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
    const classes = useStyles();
    // console.log(format(dateRange.startDate, "yyyy/MM/dd/"));
    // console.log(format(dateRange.endDate, "yyyy/MM/dd/"));
    const [branchidNo, setbranchidNo] = useState(get_cookies('branchidno'));
    const [downloadFlag, setDownloadFlag] = useState(false);

	// Data Fetching
	useEffect(() => {
        setDataLoaded(true);
    }, []);
    
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

    useEffect(() => {
        if(posts.length > 0){
            setDownloadFlag(true);
        }else{
            setDownloadFlag(false);
        }
    }, [posts]);

    //search button
	const dataFilter = async () => {
        setDataLoaded(false);
         await axios.get(
                `${process.env.REACT_APP_API_URL}/get_po_listing`, {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: branchidNo,  //branchidNo
            }
        }).then(function (res) {
			setPosts(res.data.data);
		  }).catch(function (error) {	
			console.log(error);
		  });
        setDataLoaded(true);
    }

    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
    };
    
    const columns = [
            {
                name: "date",
                label: "Date",
                options: {
                    sort:true,
                },
            },
            {
                name: "pono",
                label: "Pono",
                options: {
                    sort:true,
                },
            },
            {
                name: "supplier",
                label: "Supplier",
                options: {
                    sort:true,
                },
            },
            {
                name: "amount",
                label: "Amount",
                options: {
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                                <div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
                        );
                      }
                    }
            },
            {
                name: "receive_status",
                label: "Receive Status",
                options: {
                    sort:true,
                },
            },
            {
                name: "po_status",
                label: "PO Status",
                options: {
                    sort:true,
                },
            },
			{
				name: "pono",
				label:"Actions",
				options: {
                    sort:false, 
                    filter: false, 
				  customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <NavLink to={"/purchases/purchases-order-approval-history-view/"+value+"/"+branchidNo}>
                                    <Button variant="contained" color="primary">
                                        View
                                    </Button>	
                                   </NavLink> 
                            </Grid>
                        </Grid>
                    );	
				  },download: false 
				}
			}
        ];
 
        const options = {
            filter: true,
            // filterType: "dropdown",
            selectableRows: "none",
            filterType: "multiselect",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                console.log(colIndex, colName, data);
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
            download: downloadFlag,  //add this
            print: downloadFlag, //add this
            downloadOptions: {
				filename : 'PurchaseOrderListing.csv' //change filename of csv
			}
            // tableBodyHeight,
        };

        const style = {
            marginBottom: '1rem',
        };

        return (
            		<div className="page">
            			<div className="page-header">
            				<div className="page-icon">
            					<AssessmentTwoTone />
            				</div>
            				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
							<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
            				<h4 className="header-title">Purchase Order Listing</h4>
            			</div>
                        <div className="page-container">
                           <div style={style}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Select Date"
                                            variant="outlined"
                                            onFocus={() => setOpen(true)}
                                            fullWidth={true}
                                            autoComplete="off"
                                            value={`${format(
                                                dateRange.startDate,
                                                "MM/dd/yyyy"
                                            )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                        />
                                        <DateRangePicker
                                            open={open}
                                            toggle={toggle}
                                            onChange={(range) => dateRangeHandler(range)}
                                        /> 
                                    </Grid>
                                    <Grid item xs={1} lg={1} xl={1}>
                                        <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                                    </Grid>
                                </Grid>        
                            </div>
                        
            				{!dataLoaded ? (
            					<Preloader />
            				) : (
            					<MUIDataTable
            						title={
            							<div>
            						
            								<div className="table-title">
                                             Purchase Order Listing
            								</div>
            							</div>
            						}
            						data={posts}
            						columns={columns}
            						options={options}
            					/>
            				)}
            			</div>
            		</div>
            	);
};
 
export default PurchaseOrderListing;